export const CTA_BLOCK_s3 =  {
  "blockType": "CTA",
  "blockDesign": "CTADesign1",
  "editFormName": "CTA_01_FORM",
  "styleProps": {
    "background-color": "",
    "padding": "120px 20px 120px 20px",
    "background-image": "url('https://images.pexels.com/photos/2156881/pexels-photo-2156881.jpeg?auto=compress&cs=tinysrgb&w=600')"
  },
  "headings": [
    {
      "text": "Launch your own innovative business solution",
      "styleProps": {
        "text-align": "center",
        "font-size": "4.5rem",
        "line-height": "1",
        "padding": "50px 0px 30px 0px",
        "color": "#FBFBFB",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "font-family-bk": "'Lato', sans-serif",
        "font-weight": "900",
        "margin": "0px 0px 40px 0px"
      },
      "alignStyleProps": {
        "text-align": "center",
        "max-width": "998px",
        "margin": "0px auto 0px auto"
      },
      "stylePropsTab": {
        "font-size": "3.75rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "3rem",
        "line-height": "1"
      }
    }
  ],
  "showBtnSec": false,
  "btnSecStyleProps": {},
  "btnSecStylePropsTab": {},
  "btnSecStylePropsMob": {},
  "buttons": [
    {
      "text": "➤  Get Started",
      "alt": "Click Here",
      "href": "https://yahoo.com",
      "styleProps": {
        "background-color": "#383838",
        "color": "#ffffff",
        "border-color": "#3b82f680",
        "border-radius": "1rem",
        "padding": "14px 40px 14px 40px",
        "border-width": "0px"
      },
      "openType": "sametab"
    }
  ],
  "showEmailSec": true,
  "emailSecStyleProps": {
    "background-color": "",
    "border-radius": "9999px",
    "padding": "10px 10px 10px 10px"
  },
  "subscription": {
    "showSection": "show",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "Enter your email",
      "styleProps": {
        "color": "#333333",
        "background-color": "",
        "font-weight": "200",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "padding": "1px 12px 1px 12px"
      }
    },
    "buttonText": {
      "text": "Get Started Today",
      "styleProps": {
        "background-color": "#000000",
        "color": "#ffffff",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "12px 12px 12px 12px"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "metaDataId": 1746187810030,
  "afterIndex": 8,
  "blockId": 1746187810030,
  "containerStyleProps": {
    "padding": "0px 00px 0px 0px"
  },
  "containerStylePropsTab": {
    "padding": "0px 0px 0px 0px"
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}